<template>
  <v-dialog v-model="dialog" max-width="600" style="z-index: 5000;" @keydown.esc="cancel">
    <v-card>
      <v-card-title class="pb-2">
        <span v-if="suggestedUserStories.length > 1">My story update suggestions</span>
        <div v-else-if="suggestedUserStories.length">
          <v-btn class="text-decoration-none mr-3 mb-2" icon @click="cancel">
            <v-icon size="25">mdi-arrow-left</v-icon>
          </v-btn>
          Suggestion by {{suggestedUserStories[0]?.familyMemberName}}
        </div>
      </v-card-title>
      <v-card-text class="pl-5 pb-2">
        <v-list two-line v-if="suggestedUserStories.length > 1">
            <v-list-item v-for="(item, i) in suggestedUserStories" :key="i">
              <v-list-item-content>
                <v-list-item-title>By {{item.familyMemberName}}</v-list-item-title>
                <p class="text-gray story-wrapper v-list-scrollable">{{item.userStory}}</p>
                <v-list-item-subtitle class="text-gray text-sm color-lightgray">{{item.dateTimeDisplay}}</v-list-item-subtitle>
              </v-list-item-content>
              <v-list-item-action style="flex-direction: inherit" class="align-items-start">
                 <v-btn color="error" class="mr-2" @click="reject(item)" text>{{$t('GeneralTranslations.Reject')}}</v-btn>
                 <v-btn color="primary" @click="update(item)">{{$t('GeneralTranslations.Update')}}</v-btn>
              </v-list-item-action>
            </v-list-item>
        </v-list>
        <div v-else-if="suggestedUserStories.length">
          <div class="story-wrapper color-black v-list-scrollable">{{suggestedUserStories[0].userStory}}</div>
          <div class="text-gray text-sm">{{suggestedUserStories[0].dateTimeDisplay}}</div>
        </div>
      </v-card-text>
      <v-card-actions v-if="suggestedUserStories.length > 1" class="pb-4">
        <v-spacer></v-spacer>
        <v-btn color="primary" class="mr-4" @click="cancel" outlined>{{$t('GeneralTranslations.Cancel')}}</v-btn>
      </v-card-actions>
      <v-card-actions v-else-if="suggestedUserStories.length" class="pb-4">
        <v-btn color="primary" class="mr-4" @click="cancel" outlined>{{$t('GeneralTranslations.Cancel')}}</v-btn>
        <v-spacer></v-spacer>
        <v-btn color="error" class="mr-2" @click="reject(suggestedUserStories[0])" text>{{$t('GeneralTranslations.Reject')}}</v-btn>
        <v-btn color="primary" @click="update(suggestedUserStories[0])">{{$t('GeneralTranslations.Update')}}</v-btn>
      </v-card-actions>
    </v-card>
   
  </v-dialog>
</template>

<script>
import firebase from "firebase";

export default {
  name: "SuggestedUserStoriesDialog",
  props: {
    suggestedUserStories: {
        type: Array,
        required: true
    },
    residentId : {
        type: String,
        required: true
    }
  },
  data() {
    return {
      dialog: false
    }
  },
  methods: {
    open() {
      this.dialog = true;
    },
    cancel() {
      this.dialog = false;
    },
    async reject(suggestedUserStory) {
      if(!suggestedUserStory) return

      const residentSnap = await firebase.firestore().collection('residents').doc(this.residentId).get()
      const resident = residentSnap.data()
      this.suggestedUserStories = this.suggestedUserStories.filter(s => !(s.userStory === suggestedUserStory.userStory && s.familyMemberId === suggestedUserStory.familyMemberId))
      const newSuggestedUserStories = resident.suggestedUserStories.filter(s => !(s.userStory === suggestedUserStory.userStory && s.familyMemberId === suggestedUserStory.familyMemberId))
      residentSnap.ref.update({ suggestedUserStories: newSuggestedUserStories }).then(async () => {
        await this.$store.dispatch('getResident', this.residentId);
      });
      if(newSuggestedUserStories.length === 0){
        this.dialog = false;
      }
    },
    async update(suggestedUserStory) {
      if(!suggestedUserStory) return

      const residentSnap = await firebase.firestore().collection('residents').doc(this.residentId).get()
      const resident = residentSnap.data()
      const newSuggestedUserStories = resident.suggestedUserStories.filter(s => !(s.userStory === suggestedUserStory.userStory && s.familyMemberId === suggestedUserStory.familyMemberId))
     
      residentSnap.ref.update({ aboutMe: suggestedUserStory.userStory, suggestedUserStories: newSuggestedUserStories }).then(async () => {
        this.dialog = false;
        this.$toast.open({ message: this.$t('SuggestedUserStoriesDialog.MyStoryUpdated'), type: "success"})
        await this.$store.dispatch('getResident', this.residentId);
      });
    }
  },
};
</script>

<style scoped>
.text-sm{
  font-size: 12px;
}

.color-lightgray{
  color: lightgray;
}

.color-black{
  color: #292929;
}

.story-wrapper{
  max-height: 300px;
  overflow-y: auto;
  cursor: text
}

.v-list-item:hover{
  background-color: rgb(235, 234, 234);
}
</style>
